export default __webpack_public_path__ + "prothoma-colored.png";